import React, { FC, useEffect, useMemo } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { shallowEqual, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { useAppDispatch, useAppSelector } from "../../../hooks/reduxHook";
import useWindowSize from "../../../hooks/useWindowSize";
import { fetchBarracksBuildingInfo } from "../../../redux/pages/barracks/barracksActions";
import { BarracksState } from "../../../redux/pages/barracks/barracksSlice";
import { useBarracksUIContext } from "../BarracksContext";
import { RootState } from "../../../redux/store";
import PageHeader from "../../../components/PageHeader";
import { useAppTranslation } from "../../../i18n/useAppTranslation";

type Props = {};

const BarracksInfo: FC<Props> = (props) => {
  const dispatch = useAppDispatch();
  const { t } = useAppTranslation(["barracks"]);

  const windowSize = useWindowSize();
  const barracksContext = useBarracksUIContext();
  const { selectedTab, campInfo } = useMemo(() => {
    return {
      campInfo: barracksContext?.campInfo,
      selectedTab: barracksContext?.selectedTab,
    };
  }, [barracksContext?.selectedTab, barracksContext?.campInfo]);
  const { barrackBuildingInfo }: BarracksState = useSelector<RootState>(
    ({ barracks }) => {
      return {
        barrackBuildingInfo: barracks.barrackBuildingInfo,
      };
    },
    shallowEqual
  ) as BarracksState;

  useEffect(() => {
    dispatch(fetchBarracksBuildingInfo());
  }, [dispatch]);

  return (
    <div className={windowSize?.width <= 800 ? "w-100" : ""}>
      <div className="p-relative d-flex align-items-center justify-content-between">
        {/* Barracks already had its title; PageHeader adds the back arrow the
            design asks for and keeps the level badge alongside it. */}
        <PageHeader
          className="mb-0"
          title={selectedTab === "camp" ? t("barracks:labels.arenaCamp") : t("barracks:title")}
          extra={
            <button
              style={{ fontSize: 21, margin: 0 }}
              className="level-btn brk-step1 fw-bold text-light  mx-2"
            >
              {selectedTab==="camp"? campInfo?.arenaLevel:  barrackBuildingInfo?.level}
            </button>
          }
        />
        {/* {windowSize?.width <= 800 && barrackBuildingInfo?.level !== 8 && (
          <Link className="brk-step7" to="/home#upgrade-barracks">
            Upgrade
          </Link>
        )} */}
      </div>

      <div className="brk-step2 light-yellow text-shadow">
        <small>
          {t("barracks:labels.capacity")} :
          {selectedTab === "camp" ? (
            <>
              {campInfo?.troopsCount}/ {campInfo?.arenaCampCapacity}
            </>
          ) : (
            <>
              {barrackBuildingInfo?.currentCapacity}/
              {barrackBuildingInfo?.thisLevelCapacity}
            </>
          )}
        </small>
        &nbsp;
        {selectedTab !== "camp" && (
          <small>
            - {t("barracks:labels.trainingQueue")} : {barrackBuildingInfo?.trainingQueue}/
            {barrackBuildingInfo?.maxTrainingQueue}
          </small>
        )}{" "}
        <br />
        {selectedTab !== "camp" && ( <small>
          <OverlayTrigger
            placement="bottom"
            flip
            overlay={
              <Tooltip className="fs-tiny" {...props}>
                {t("barracks:tooltips.dailyHealing")}
              </Tooltip>
            }
            delay={{ show: 100, hide: 200 }}
          >
              <span>
                {t("barracks:labels.dailyHealing")}{" "}
              <img
                width={15}
                height={15}
                src={"/assets/images/icons/info.svg"}
                alt="info"
              />
            </span>
          </OverlayTrigger>{" "}
          : {barrackBuildingInfo?.currentDailyProduction} -
        </small>)}
        &nbsp;
        <small>
          <OverlayTrigger
            placement="bottom"
            flip
            overlay={
              <Tooltip className="fs-tiny" {...props}>
                {t("barracks:tooltips.bonusStats")}
              </Tooltip>
            }
            delay={{ show: 100, hide: 200 }}
          >
              <span>
                {t("barracks:labels.bonusStats")}{" "}
              <img
                width={15}
                height={15}
                src={"/assets/images/icons/info.svg"}
                alt="info"
              />
            </span>
          </OverlayTrigger>{" "}
          : {barrackBuildingInfo?.bonusStats}%{" "}
        </small>
      </div>
    </div>
  );
};

export default BarracksInfo;
